import { Autocomplete, Avatar, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemSecondaryAction, ListItemText, Paper, Stack, TextField, Tooltip, Typography } from '@mui/material'
import React from 'react'
import { useEmail } from '../../core/MailLoader'
import { AirplaneTicketOutlined, AttachFile, Done, DoneOutline, InsertDriveFileOutlined, SaveOutlined } from '@mui/icons-material'
import { useDispatch } from 'react-redux'
import { CreateCommunicationLogMutation } from '../../modules/Timer/mutations/CreateCommunicationLogMutation'
import { CommunicationLogInput, UploadDocumentInput } from '../../modules/Timer/types'
import useAlert from '../../core/useAlert'
import { LoadingButton } from '@mui/lab'
import { GetCommunicationMutation } from '../../modules/Timer/mutations/GetCommunicationMutation'
import { UploadDocumentMutation } from '../../modules/Timer/mutations/UploadDocumentMutation'
import { useAppSelector } from '../../store/hooks'
import { getDocType } from '../../utils/getDocType'
import { GetDocumentByResourceIdMutation } from '../../modules/Timer/mutations/GetDocumentByResourceIdMutation'
import Spinner from '../../components/Spinner'
import { Controller, useForm } from 'react-hook-form'
import { timerActions } from '../../store/timerSlice'
import { GetMatterDependencyDataMutation } from '../../modules/Timer/mutations/GetMatterDependencyDataMutation'
import _ from 'lodash'

export interface InboxProps {

}
export interface CommunicationUpdateFormProps {
    open: boolean;
    onClose: () => void;
    onSubmit: (values: CommunicationLogInput) => void;
    defaultValues: CommunicationLogInput;
}
export interface AddCommunicationProps extends Omit<CommunicationUpdateFormProps, 'defaultValues' | 'onSubmit'> {
    setIsCommLogged: (args: boolean) => void
    setDocumentLoading: (args: boolean) => void
    setCommLoading: (args: boolean) => void
    refetchCommunication: () => void
}
const CommunicationUpdateForm: React.FC<CommunicationUpdateFormProps> = ({
    open,
    onClose,
    onSubmit,
    defaultValues,
}) => {

    const matters = useAppSelector((state) => state.timer.matters);
    const createEmailLogLoading = useAppSelector(state => state.timer.createEmailLogLoading)
    const options = matters!;
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        control,
    } = useForm({
        defaultValues,
        // resolver: yupResolver(schema as unknown as any),
    });
    return (
        <React.Fragment>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason === "backdropClick") return; // disable backdrop close
                }}
                disableEscapeKeyDown
            >
                <DialogTitle>Create Email Log</DialogTitle>
                <DialogContent>
                    <form onSubmit={handleSubmit(onSubmit)} id="time-entry-form">
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <Controller
                                    name="matter"
                                    control={control}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            options={options}
                                            getOptionLabel={(option) => option?.matterTitle || ""}
                                            onChange={(_, value) => field.onChange(value)} // ⭐ set RHF value
                                            renderInput={(params) => (
                                                <TextField {...params} label={options.length ? "Select matter" : "No Matters"} size="small" />
                                            )}

                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                    </form>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={() => {
                            onClose();
                        }}
                    >
                        Cancel
                    </Button>
                    <LoadingButton loading={createEmailLogLoading} type="submit" form="time-entry-form">
                        Save
                    </LoadingButton>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
};
const AddCommunicationLog: React.FC<AddCommunicationProps> = ({ setIsCommLogged, setDocumentLoading, refetchCommunication, setCommLoading, ...props }) => {
    const dispatch = useDispatch()
    const showAlert = useAlert()
    const { mailFrom, mailTo, mailSubject, mailBody, attachments, mailId, getAttachmentContent } = useEmail()

    const initialValues: CommunicationLogInput = {
        resourceId: mailId,
        resourceType: 1,
        messageFrom: [mailFrom],
        messageTo: mailTo,
        matterId: '',
        messageBody: mailBody,
        subject: mailSubject,
        dateOn: new Date().toISOString(),
    }

    const refetchDocuments = (resourceId: string) => {
        dispatch(GetDocumentByResourceIdMutation(resourceId))
    }

    const handleSaveEmailLog = (values: CommunicationLogInput) => {
        setCommLoading(true)
        dispatch(timerActions.getCreateEmailLogLoading(true))
        const payload: CommunicationLogInput = _.omit({
            ...values,
            resourceId: mailId,
            messageFrom: [mailFrom],
            messageTo: mailTo,
            matterId: values?.matter?.id!,
            messageBody: mailBody,
            subject: mailSubject,
        }, 'matter')
        dispatch(CreateCommunicationLogMutation(payload, {
            onSuccess: (commResponse: any) => {
                showAlert("Email log saved successfully!", {
                    variant: 'success'
                })
                setIsCommLogged(Boolean(commResponse?.resourceId!))
                if (attachments.filter(att => {
                    const docType = getDocType(att.name)
                    return Boolean(docType)
                }).length) {
                    setTimeout(() => {
                        showAlert("Please wait until the documents are uploaded....", {
                            variant: 'info'
                        })
                        for (const file of attachments) {
                            setDocumentLoading(true)
                            const docType = getDocType(file.name)
                            getAttachmentContent(file.id, {
                                onSuccess: (attachResponse) => {
                                    const payload: UploadDocumentInput = {
                                        fileName: file.name,
                                        communicationId: commResponse?.id!,
                                        docType,
                                        fileBase64: attachResponse.value.content!,
                                        addOnType: 2
                                    }
                                    dispatch(UploadDocumentMutation(payload, {
                                        onSuccess: () => {
                                            showAlert(`Document ${file.name} saved to document`, {
                                                variant: 'success'
                                            })
                                            refetchDocuments(commResponse?.id!)
                                            refetchCommunication()
                                        },
                                        onLoading: setDocumentLoading
                                    }))
                                },

                            })
                        }
                    }, 1000)
                }
                refetchCommunication()
                props?.onClose()
            },
            onLoading: (loading) => {
                setCommLoading(loading)
                dispatch(timerActions.getCreateEmailLogLoading(loading))
            }
        }))
    }

    return (
        <CommunicationUpdateForm
            {...props}
            defaultValues={initialValues}
            onSubmit={handleSaveEmailLog}
        />
    )
}
const InboxComponent: React.FC<InboxProps> = ({ ...props }) => {
    const dispatch = useDispatch()
    const showAlert = useAlert()

    const { mailFrom, mailSubject, mailBodyHTML, attachments, mailId, } = useEmail()
    const [commLoading, setCommLoading] = React.useState(false)
    const [isCommLogged, setIsCommLogged] = React.useState(false)
    const [documentLoading, setDocumentLoading] = React.useState(false)
    const [open, setOpen] = React.useState(false);
    const documents = useAppSelector(state => state.timer.documents)
    const communication = useAppSelector(state=>state.timer.communication)
    const handleClose = () => {
        setOpen(false);
    };

    const refetchDocuments = (resourceId: string) => {
        dispatch(GetDocumentByResourceIdMutation(resourceId))
    }

    const refetchCommunication = () => {

        dispatch(
            GetCommunicationMutation([mailId], {
                onSuccess: (response: any) => {
                    setIsCommLogged(Boolean(response?.resourceId))
                },
                onLoading: setCommLoading,
                onError: (error) => showAlert(error, {
                    variant: 'warning'
                })
            })
        )
    }

    React.useEffect(() => {
        if (mailId) {
            refetchCommunication()
        }
    }, [mailId])

    React.useEffect(() => {
        if (mailFrom) {
            dispatch(
                GetMatterDependencyDataMutation([mailFrom])
            );
        }
    }, [mailFrom]);

    React.useEffect(()=>{
        if(communication?.id){
            refetchDocuments(communication?.id!)
        }
    },[communication])

    return (
        <Card
            elevation={3}
            sx={{
                borderRadius: 3,
                overflow: "hidden",
                bgcolor: "background.paper",
                marginTop: 2
            }}
        >
            <List disablePadding>

                {/* Sender Info */}
                <ListItem
                    divider
                    sx={{
                        alignItems: "flex-start",
                        py: 2,
                    }}
                >
                    <Avatar sx={{ mr: 2 }}>
                        {mailFrom?.charAt(0)?.toUpperCase()}
                    </Avatar>

                    <ListItemText
                        primary={
                            <Typography variant="subtitle2" color="text.secondary">
                                Primary Client
                            </Typography>
                        }
                        secondary={
                            <Typography
                                variant="body1"
                                sx={{
                                    mt: 0.5,
                                    fontWeight: 500,
                                    color: "text.primary",
                                }}
                            >
                                {mailFrom}
                            </Typography>
                        }
                    />
                </ListItem>

                {/* Subject + Body */}
                <ListItem
                    divider
                    sx={{
                        display: "block",
                        py: 2,
                    }}
                >
                    <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        mb={1}
                    >
                        <Typography variant="h6" fontWeight={600}>
                            {mailSubject}
                        </Typography>

                        {isCommLogged && (
                            <Tooltip title="Email Logged"><Done color="success" fontSize="small" /></Tooltip>
                        )}
                    </Stack>

                    <Paper
                        variant="outlined"
                        sx={{
                            p: 2,
                            borderRadius: 2,
                            maxHeight: 300,
                            overflow: "auto",
                            bgcolor: "#fafafa",
                        }}
                    >
                        <Typography
                            variant="body2"
                            component="div"
                            sx={{
                                color: "text.secondary",
                                "& img": {
                                    maxWidth: "100%",
                                },
                            }}
                            dangerouslySetInnerHTML={{ __html: mailBodyHTML }}
                        />
                    </Paper>
                </ListItem>

                {/* Attachments */}
                <ListItem
                    divider
                    sx={{
                        display: "block",
                        py: 2,
                    }}
                >
                    <Stack direction="row" spacing={1} alignItems="center" mb={1}>
                        <AttachFile fontSize="small" />
                        <Typography variant="subtitle1" fontWeight={600}>
                            Attachments
                        </Typography>
                    </Stack>

                    {attachments?.length > 0 ? (
                        <Stack spacing={1}>
                            {attachments.map((file: any) => (
                                <Paper
                                    key={file.id}
                                    variant="outlined"
                                    sx={{
                                        p: 1.5,
                                        borderRadius: 2,
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        alignItems="center"
                                        {
                                        ...(!Boolean(getDocType(file.name)) ? {
                                            color: 'red'
                                        } : {})
                                        }


                                    >
                                        <InsertDriveFileOutlined
                                            fontSize="small"
                                            color="action"
                                        />

                                        <Typography variant="body2">
                                            {file.name}
                                        </Typography>
                                        {
                                            documents.some(document => document.title === file.name) && <Tooltip title="Document Saved"><Done color="success" fontSize="small" /></Tooltip> || null
                                        }
                                        {
                                            documentLoading && <Spinner />
                                        }

                                    </Stack>
                                </Paper>
                            ))}
                        </Stack>
                    ) : (
                        <Typography variant="body2" color="text.secondary">
                            No attachments available
                        </Typography>
                    )}
                </ListItem>

                {/* Action Button */}
                {!isCommLogged && (
                    <ListItem sx={{ p: 2 }}>
                        <LoadingButton
                            loading={commLoading}
                            onClick={() => setOpen(true)}
                            fullWidth
                            type="button"
                            variant="contained"
                            size="large"
                            sx={{
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                            }}
                        >
                            Save to Email Log
                        </LoadingButton>
                    </ListItem>
                )}
                <AddCommunicationLog
                    onClose={handleClose}
                    open={open}
                    setCommLoading={setCommLoading}
                    setDocumentLoading={setDocumentLoading}
                    setIsCommLogged={setIsCommLogged}
                    refetchCommunication={refetchCommunication}
                />
            </List>
        </Card>
    )
}

export default InboxComponent